import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Importing Tailwind CSS styles
import App from './App'; // Main app component

const root = ReactDOM.createRoot(document.getElementById('root')); // Targeting the root div in index.html
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
